import { createSelector } from 'reselect'

import { getApiMeetings } from '../api/selectors'
import { getSelectedTopicId } from '../selected/selectors'

export const getSelectedTopicMeetings = createSelector(
  [getSelectedTopicId, getApiMeetings],
  (topicId, meetings) => {
    return Object.values(meetings)
      .filter(
        (meeting) =>
          meeting.topic_id === topicId &&
          meeting.status !== 'past' &&
          meeting.status !== 'cancelled',
      )
      .sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
  },
)

export const makeGetMeeting = () =>
  createSelector([getApiMeetings, (_, id) => id], (meetings, id) => {
    return meetings[id]
  })
